import React from 'react';
import styled from 'styled-components';

export default function OperateTitle({ label, title, operator }) {
  return (
    <Root>
      <Label>{label}</Label>
      <Title>{title}</Title>
      {operator}
    </Root>
  );
}

const Root = styled.div`
  background-color: #f7f8fa;
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
`;

const Label = styled.div`
  font-size: 14px;
  color: var(--td-text-color-secondary);
`;

const Title = styled.div`
  font-size: 16px;
  flex: 1;
  color: var(--td-text-color-primary);
  font-weight: bolder;
`;
